import React, {
  useEffect,
  useState,
  useImperativeHandle,
  forwardRef,
} from "react";
import { EditOutlined } from "@ant-design/icons";

import { Table, Button } from "antd";
import moment from "moment";

import { all as AllSurgicalInterventionTransfer } from "../../api/SurgicalInterventionTransfer";

const TransfersInterventionTable = forwardRef((props, ref) => {
  const {surgicalIntervention} = props;
  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
  });

  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);

  const columns = [
    {
      title: "Unité",
      dataIndex: "care_unit",
      render: (data) => {
        return data.name;
      }
    },
    {
      title: "Date de début",
      dataIndex: "start_at",
      align: "right",
      sorter: true,
      defaultSortOrder: 'descend',
      render: (data) => {
        if (!data) {
          return "";
        }

        return moment(data).format("DD/MM/YYYY");
      }
    },
    {
      title: "Date de fin",
      dataIndex: "end_at",
      align: "right",
      render: (data) => {
        if (!data) {
          return "";
        }

        return moment(data).format("DD/MM/YYYY");
      }
    },
    {
      render: (data) => {
        return (
          <Button
            type="primary"
            shape="circle"
            icon={<EditOutlined />}
            size="large"
            onClick={() => props.onEdit(data.id)}
          ></Button>
        );
      },
      width: "30px",
    },
  ];

  let getParams = (pagination, sorter) => {
    let params = {
      current: pagination.current,
      pageSize: pagination.pageSize,
    };

    if (sorter !== undefined && sorter.column !== undefined) {
      let { field, order } = sorter;
      order = (order === 'ascend') ? 1 : -1;

      if (!!field && !!order) {
        params['sort'] = field + "," + order;
      }
    }

    return params;
  };

  let fetch = async function (pagination, filters, sorter) {
    setLoading(true);

    let params = getParams(pagination, sorter);
    params['q'] = {
      'surgical_intervention_id': surgicalIntervention.id
    }

    AllSurgicalInterventionTransfer(params)
      .then((data) => {
        setData(data.results);
        setPagination({
          ...pagination,
          total: data.total,
        });
        setLoading(false);
      });
  };

  useEffect(() => {
    if (surgicalIntervention) {
      fetch(pagination);
    }
  }, [surgicalIntervention]);

  useImperativeHandle(ref, () => ({
    fetch: () => {
      fetch(pagination);
    },
  }));

  return (
    <Table
      columns={columns}
      rowKey={(record) => record.id}
      dataSource={data}
      pagination={pagination}
      loading={loading}
      onChange={fetch}
    />
  );
});

export default TransfersInterventionTable;
